import dayjs from 'dayjs';
import { TimePeriod, Period } from '@/types/date';
import { SelectItem } from '@/types/ui';
import { formatPeriod, getPeriodUntilDate } from '@/utils/date';

export const getDateRangeFilterOptions = (): SelectItem<Period>[] => [
  {
    label: 'Weekly',
    value: getPeriodUntilDate(dayjs(), TimePeriod.WEEK),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs(), TimePeriod.WEEK)),
  },
  {
    label: 'Monthly',
    value: getPeriodUntilDate(dayjs(), TimePeriod.MONTH),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs(), TimePeriod.MONTH)),
  },
  {
    label: 'Quarterly',
    value: getPeriodUntilDate(dayjs(), TimePeriod.QUARTER),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs(), TimePeriod.QUARTER)),
  },
  {
    label: 'YTD',
    value: getPeriodUntilDate(dayjs(), TimePeriod.YTD),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs(), TimePeriod.YTD)),
  },
  {
    label: 'Annually',
    value: getPeriodUntilDate(dayjs(), TimePeriod.YEAR),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs(), TimePeriod.YEAR)),
  },
  {
    label: 'Custom',
    value: getPeriodUntilDate(dayjs(), TimePeriod.CUSTOM),
    additionalInfo: 'Choose your dates',
  },
];

export default getDateRangeFilterOptions;
